import { createAction } from '@reduxjs/toolkit';

/**
 * Payload describing a widget state change event to be used by UI/middleware listeners.
 */
export type WidgetStateChangedPayload = {
  /** The id of the recipe in the in-memory pool */
  recipeId: string;
  /** The id of the thing in the recipe (block recipe id) */
  thingId: string;
  /** The id of the widget whose state changed */
  widgetId: string;
};

/**
 * Dispatched after a widget's state has been updated in the recipe cache.
 * Middleware can coalesce these events and capture a snapshot for undo/redo.
 */
export const widgetStateChanged = createAction<WidgetStateChangedPayload>('ui/widgetStateChanged');


